import React, {CSSProperties, ReactElement, useState} from "react";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {COLOURS, THEME} from "@components/core/theme";
import {Fade} from "@components/interface/Fade";

const styles: Record<string, CSSProperties> = {
    alert: {
        backgroundColor: COLOURS.parchment,
        border: `2px solid ${COLOURS.agedBorder}`,
        borderRadius: 8,
        boxShadow: "0 8px 32px rgba(0,0,0,0.45)",
        display: "flex",
        flexDirection: "column",
        margin: 16,
        maxHeight: "80vh",
        maxWidth: 400,
        padding: 16,
        width: "calc(100% - 64px)"
    },
    bottomBar: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: 8
    },
    contents: {
        alignItems: "flex-start",
        backgroundColor: COLOURS.overlay,
        display: "flex",
        justifyContent: "center",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        paddingTop: "10vh",
        position: "absolute",
        zIndex: 200
    },
    spacer: {
        flexGrow: 1
    }
};

interface IAlert {
    buttons?: ReactElement[]
    children: ReactElement | ReactElement[]
    onClose: () => void
}

export function Alert({buttons = [], children, onClose}: IAlert) {
    const [visible, setVisible] = useState(true);

    const handleOKClick = () => setVisible(false);

    return (
        <Fade onFadeOut={onClose} visible={visible}>
            <div style={styles.contents}>
                <div style={styles.alert}>
                    {children}
                    <div style={styles.spacer}/>
                    <div style={styles.bottomBar}>
                        {buttons}
                        <button onClick={handleOKClick} style={THEME.button}>
                            <LocalisedTypography content="ButtonOK"/>
                        </button>
                    </div>
                </div>
            </div>
        </Fade>
    );
}
